export enum AppAction {
    SET_LOADING = 'GTVM/APP/SET_LOADING',
    SET_ERROR = 'GTVM/APP/SET_ERROR',
    SET_PRODUCT_DETAILS = 'GTVM/APP/SET_PRODUCT_DETAILS',
    GET_PRODUCT_DETAILS = 'GTVM/APP/GET_PRODUCT_DETAILS',
};
